import {Action, AnyAction, Dispatch} from 'redux';
import initialState from '../initialState';
import {NotificationActions} from './notification/notification-actions';
import {AppDispatch} from './index';
import {getApi} from '../api/ApiProvider';
import {default as StoreModel, LoadedResource, LoadedSingleResource} from './StoreModel';
import {Client} from '../api/model';

export enum ClientActionTypes {
    FETCH_REQUEST = '[CLIENT][LIST] Request',
    FETCH_RESPONSE = '[CLIENT][LIST] Response',
    FETCH_ERROR = '[CLIENT][ERROR] error',
    ADD_USER_REQUEST = '[CLIENT][ADD] Request',
    ADD_USER_RESPONSE = '[CLIENT][ADD] Response',
    ADD_USER_ERROR = '[CLIENT][ADD] Error',
    SINGLE_FETCH = '[CLIENT][REQUEST] single',
    SINGLE_RESULT = '[CLIENT][RESPONSE] single',
    SINGLE_ERROR = '[CLIENT][ERROR] single',
    UPDATE_USER_REQUEST = '[CLIENT][UPDATE] Request',
    UPDATE_USER_RESPONSE = '[CLIENT][UPDATE] Response',
    UPDATE_USER_ERROR = '[CLIENT][UPDATE] Error',
}

export interface ClientState {
    data: LoadedResource<Client>,
    dataClient: LoadedSingleResource<Client>,
    add: LoadedSingleResource<Client>
}

export default (state: ClientState = initialState.client, action?: Action<ClientActionTypes> & { payload: any }): ClientState => {

    if (!action) {
        return state;
    }

    switch (action.type) {
        case ClientActionTypes.FETCH_REQUEST:
            return {
                ...state,
                data: StoreModel.fetching()
            };

        case ClientActionTypes.FETCH_RESPONSE:
            return {
                ...state,
                data: StoreModel.result(action.payload)
            };

        case ClientActionTypes.FETCH_ERROR:
            return {
                ...state,
                data: StoreModel.error(action.payload)
            };

        case ClientActionTypes.ADD_USER_REQUEST:
            return {
                ...state,
                add: StoreModel.fetchingSingle()
            };
        case ClientActionTypes.ADD_USER_RESPONSE:
            if (StoreModel.isLoaded(state.data)) {
                return {
                    ...state,
                    data: {...state.data, data: state.data.data.concat(action.payload)},
                    add: StoreModel.resultSingle(action.payload)
                }
            }
            return {
                ...state,
                add: StoreModel.resultSingle(action.payload)
            };
        case ClientActionTypes.ADD_USER_ERROR:
            return {
                ...state,
                add: StoreModel.errorSingle(action.payload)
            };

        case ClientActionTypes.SINGLE_FETCH:
            return {
                ...state,
                dataClient: StoreModel.fetchingSingle()
            };

        case ClientActionTypes.SINGLE_RESULT:
            return {
                ...state,
                dataClient: StoreModel.resultSingle(action.payload)
            };

        case ClientActionTypes.SINGLE_ERROR:
            return {
                ...state,
                dataClient: StoreModel.errorSingle(action.payload)
            };

        case ClientActionTypes.UPDATE_USER_REQUEST:
            return {...state, dataClient: StoreModel.fetchingSingle()};

        case ClientActionTypes.UPDATE_USER_RESPONSE:
            return {...state, dataClient: StoreModel.resultSingle(action.payload)};

        case ClientActionTypes.UPDATE_USER_ERROR:
            return {...state, dataClient: StoreModel.errorSingle(action.payload)};

        default:
            return state;
    }
};

export class ClientActions {

    add(data: { name: string, document: string, email: string }) {
        return (dispatch: AppDispatch) => {
            const notif = new NotificationActions();

            dispatch({type: ClientActionTypes.ADD_USER_REQUEST});

            getApi().client().add(data).then(response => {

                dispatch(notif.addSuccess('Usuario', 'Usuario agregado'));
                dispatch({type: ClientActionTypes.ADD_USER_RESPONSE, payload: response});

            }).catch(err => {

                dispatch(notif.addError('Usuario', 'Fallo al agregar'));
                dispatch({type: ClientActionTypes.ADD_USER_ERROR, payload: err});

            })

        }
    }

    update(data: Client) {
        return (dispatch: Dispatch) => {
            const notif = new NotificationActions();
            const dato= {
                name: data.user.name, 
                document: data.document, 
                email: data.user.email,
                phone: data.phone ? data.phone : null,
                // observation: data.observation ? data.observation : null
            }
            dispatch({type: ClientActionTypes.ADD_USER_REQUEST});
            getApi().client().update(parseInt(data.id, 10), dato).then(response => {
                dispatch(notif.addSuccess('Usuario', 'Usuario actualizado') as unknown as AnyAction);
                dispatch({type: ClientActionTypes.UPDATE_USER_RESPONSE, payload: response});
            }).catch(err => {
                dispatch(notif.addError('Cliente', 'Fallo al actualizar') as unknown as AnyAction);
                dispatch({type: ClientActionTypes.UPDATE_USER_ERROR, payload: err});

            })
        }
    }

    fetch() {
        return (dispatch: Dispatch) => {
            dispatch({type: ClientActionTypes.FETCH_REQUEST});
            getApi().client().list().then(data => {
                dispatch({type: ClientActionTypes.FETCH_RESPONSE, payload: data});
            }).catch(err => {
                dispatch({type: ClientActionTypes.FETCH_ERROR, payload: err});
            })

        }
    }
    fetchPaginate(page?: number, pageSize?: number, search?: string) {
        return (dispatch: Dispatch) => {
            dispatch({type: ClientActionTypes.FETCH_REQUEST});
            getApi().client().listPaginate(page,pageSize,search).then(data => {
                dispatch({type: ClientActionTypes.FETCH_RESPONSE, payload: data});
            }).catch(err => {
                dispatch({type: ClientActionTypes.FETCH_ERROR, payload: err});
            })

        }
    }

    fetchById(id: number) {
        return ((dispatch: Dispatch) => {
            dispatch({type: ClientActionTypes.SINGLE_FETCH});
            getApi().client().byId(id).then(data => {
                dispatch({type: ClientActionTypes.SINGLE_RESULT, payload: data});
            }).catch(err => {
                dispatch({type: ClientActionTypes.SINGLE_ERROR, payload: err});
            })
        });
    }
}


// WEBPACK FOOTER //
// ./src/store/client.ts